/* eslint-disable */
import { canAccessAcademics, isAcademicsAdmin } from '@/composables/roles';

/**
 * Router guard for the academics module.
 *
 * Attach to all /academics/* routes. If a user has none of the
 * academics roles, they're redirected to a landing page (Home by
 * default) rather than allowed to reach a page that would 403 later.
 *
 * Usage in router config:
 *
 *   import { requireAcademicsAccess } from '@/router/academicsGuard';
 *   {
 *     path: "/academics/report-colours",
 *     component: ReportColours,
 *     beforeEnter: requireAcademicsAccess,
 *   }
 *
 * For admin-only routes, use the admin variant — it additionally
 * requires ROLE_Exam_admin or ROLE_All:
 *
 *   beforeEnter: requireAcademicsAdmin,
 *
 * Both guards return either `true` (allow) or a route object (redirect).
 * Vue Router >=4 accepts this return-value pattern natively.
 */

/**
 * Any academics tier is enough — admin OR teacher access.
 * Use this for Home (module landing), My subjects, Termly conduct.
 */
export function requireAcademicsAccess() {
    if (!canAccessAcademics()) {
        // Redirect non-academics users home. If your app has a dedicated
        // "no access" page, point at that instead (and register its route).
        return { name: 'Home' };
    }
    return true;
}

/**
 * Admin tier only. Use for Exams, Lesson Plans, Dashboard, and the
 * Settings sub-menu routes (Grades, Subjects, Subject groups, etc.).
 */
export function requireAcademicsAdmin() {
    if (!isAcademicsAdmin()) {
        // Teachers who accidentally hit an admin URL go to the teacher
        // landing (My subjects) rather than bouncing out of the module
        // entirely — their session still has academics access.
        if (canAccessAcademics()) {
            return { name: 'MySubjects' };
        }
        return { name: 'Home' };
    }
    return true;
}